module.exports = __webpack_public_path__ + "static/media/3.Pipe Vice.d91a6700.jpg";